module.exports = __webpack_public_path__ + "img/start-charging-desktop-POLAND.08654a7c.webp";